import AvantageCodesFidelity from "components/AvantageCodesFidelity/AvantageCodesFidelity";
import React from "react";

function EmailAvantageDeCodeDeFidelitePage() {
  return <AvantageCodesFidelity />;
}

export default EmailAvantageDeCodeDeFidelitePage;
